import {
    COURSE_INFO,
    FEEDBACK_MSG,
    // STRESSED_PROMPTS,
    // NOTSTRESSED_PROMPTS,
} from '../../data/chatbotPrompts';

// Hash function to store the chatbot question-response pair in session storage
const hashCode = (s) => {
    return s.split('').reduce(function(a, b) {
        a = ((a << 5) - a) + b.charCodeAt(0);
        return a & a;
    }, 0);
};
// Global constants URL, Key

async function getChatGptResponse(question, conversation, results = null) {
    try {
        const API_URL = 'https://us-central1-wellbeing-49fed.cloudfunctions.net/chatgpt';
        let prompt;
        if (results) {
            const avgScore = (results.stress + results.mood + results.tiredness + results.satisfaction) / 4;
            let messageType;
            if (avgScore <= 2) {
                messageType = FEEDBACK_MSG[0];
            } else if (avgScore <= 4) {
                messageType = FEEDBACK_MSG[1];
            } else {
                messageType = FEEDBACK_MSG[2];
            }
            prompt = `
                You are an AI chatbot with knowledge about the website, Wellness Buddy! 
                Context: ${COURSE_INFO}

                ${results} - holds the results of the user based on the survey that they are asked to complete today. They are required to this every day. This 'results' variable determines their stress, mood, tiredness, and satisfaction ranked between 1 to 6 where:

                User's results are as follows:
                    - Stress Score: ${results.stress} (Scale: 1: Overwhelmed, 3: Neutral, 6: Confident)
                    - Mood Score: ${results.mood} (Scale: 1: Feeling bad, 3: Neutral, 6: Feeling good)
                    - Tiredness Score: ${results.tiredness} (Scale: 1: Sleepy, 3: Neutral, 6: Wide awake)
                    - Satisfaction Score: ${results.satisfaction} (Scale: 1: Graded F, 3: Neutral, 6: Graded A)

                Based on the results above, provide a concise message that ${messageType}. Be sure to thank them for completing the survey. Do not mention anything about their results score. 
            `;
        } else {
            const { allConvo } = { ...conversation };

            prompt = `
            You are an AI chatbot with knowledge about the website, Wellness Buddy! When the conversation is brief, your role is to respond as a helpful resource providing information on Wellness Buddy and answering questions based on the context below.

            Context: ${COURSE_INFO}

            Question: """
            ${question}
            """

            Answer as Simple Text.

            However, if the conversation is lengthy, adopt the role of an empathetic instructor. In this role, provide support and encouragement tailored to the user’s unique situation. Use comforting words and guidance to help them through challenging times. Keep responses under 70 words when in this empathetic role.

            Conversation: ${allConvo}

            `;
        }

        const questionHashKey = hashCode(question);

        if (sessionStorage.getItem(questionHashKey) && question !== '') {
            return sessionStorage.getItem(questionHashKey);
        }

        const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                model: 'gpt-3.5-turbo-0125',
                messages: [{ role: 'user', content: prompt }],
            }),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (data.choices && data.choices.length > 0) {
            const content = data.choices[0].message.content;
            sessionStorage.setItem(questionHashKey, content);
            return content;
        } else {
            return 'I did not get that, can you rephrase?';
        }
    } catch (error) {
        console.error('There was an error fetching the chat response:', error);
        return 'Sorry, there was an issue getting the response.';
    }
};

export { getChatGptResponse };
